import React from "react";
import Canonical from "../components/Canonical";

const PrivacyPolicy = () => {
  const canonicalUrl = "https://homesdekho.com/privacy-policy";
  const hrfLangTag = "https://homesdekho.com/privacy-policy";
  const title = "Privacy Policy | Your Data Privacy at HomesDekho";
  const description =
    "Learn how HomesDekho collects, uses, and protects your data. Our privacy policy ensures transparency and safeguards your information.";

  return (
    <>
      <Canonical
        canonicalUrl={canonicalUrl}
        title={title}
        hrfLang={hrfLangTag}
        description={description}
      />
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h1 className="privacy-txt mt-3">Privacy Policy</h1>
          </div>
          <div className="col-md-12">
            <p className="privacy-para">
              At HomesDekho, we prioritize protecting your privacy and ensuring
              the confidentiality of your personal information. This Privacy
              Policy outlines how we collect, use, and safeguard your data.
            </p>
            <p className="privacy-para">1. Information We Collect</p>
            <p className="privacy-para">
              - Personal Information: Includes name, contact details, and
              property preferences submitted via forms. <br />
              - Usage Data: Includes IP address, browser type, and activity on
              our website. <br />
              - Cookies: We use cookies to enhance user experience and analyze
              website performance <br />
            </p>
            <p className="privacy-para">2. Use of Information</p>
            <p className="privacy-para">
              We use collected data to: <br />
              - Provide personalized property recommendations. <br />
              - Improve our website and services. <br />- Send promotional
              offers, newsletters, or updates (opt-in only) <br />
            </p>
            <p className="privacy-para">3. Sharing of Information</p>
            <p className="privacy-para">
              We do not sell your information. Data may be shared with: <br />
              - Trusted third-party partners for service delivery. <br />
              - Legal authorities if required by law <br />
            </p>
            <p className="privacy-para">4. Data Security</p>
            <p className="privacy-para">
              We employ advanced encryption and security protocols to protect
              your data from unauthorized access.
            </p>
            <p className="privacy-para">5. Third-Party Links</p>
            <p className="privacy-para">
              Our website may contain links to external websites. We are not
              responsible for their privacy practices.
            </p>
            <p className="privacy-para">6. Your Rights</p>
            <p className="privacy-para">
              - Opt-out of promotional communications. <br />
              - Request access, correction, or deletion of your data <br />
            </p>
            <p className="privacy-para">7. Updates to Privacy Policy</p>
            <p className="privacy-para">
              This policy is subject to periodic updates. Changes will be
              notified via the website.
            </p>
            <p className="privacy-para">
              For queries, contact us at homesDekho@gmail.com
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
